import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManagePermissionsService {

  private baseUrl = 'https://www.greenteksolutions.com/web';
  
  constructor(private http: HttpClient) { }

  setUserPermission0(userId: number, type: string, value: number, token): Observable<any> {
    const url = `${this.baseUrl}/user/setuserpermissions/${userId}`;
    const body = {
      authorization: token,
      json: {type, value}
    };
    return this.http.post(url, body);
  }

  setUserPermission(userId: number, type: string, value: number, tokengts): Observable<any> {

    const datos = {
      type: type,
      value: value,
    }
    const url = `${this.baseUrl}/user/setuserpermissions/${userId}`;

    const formData = new FormData();
    formData.append('authorization', tokengts);
    formData.append('json', JSON.stringify(datos));

    return this.http.post(url, formData);
  }


  public  getHeaders(): HttpHeaders {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    return headers;
  }
  
  getUser(token: any, id: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = this.getHeaders();
    const page = 1;

    return this.http.post(`${this.baseUrl}/user/detail/${id}?page=${page}`, params, { headers })
      .pipe(map(res => res));
  }

}
